import dayjs from 'dayjs'

import { srmReportLogic } from '../report.logic'
import { execTestcase } from './libs'

export const testRunner103: Record<string, () => Promise<boolean>> = {
  '103.006': () => execTestcase({ num: 103, step: 6, device: 'A', run: () => srmReportLogic.printUserReport([dayjs().startOf('year').toDate(), dayjs().endOf('year').toDate()]) }),
  // '103.006': () => execTestcase({ num: 103, step: 6, device: 'A', run: () => srmReportLogic.printYearlyUserReport(dayjs().year()) }),
}
